import { IFakeGcp } from "../../../apiFacades/bapi/fakeGcps";

export type IFakeGcpsState = IFakeGcp[];

export const FAKE_GCPS_UPDATED = "FAKE_GCPS_UPDATED";
export const FAKE_GCP_ARCHIVE_STATUS_TOGGLED =
  "FAKE_GCP_ARCHIVE_STATUS_TOGGLED";
const FAKE_GCP_RENAMED = "FAKE_GCP_RENAMED";

export const updateFakeGcps = (
  proposedFakeGcps: IFakeGcp[],
): IAction<IFakeGcp[]> => ({
  payload: proposedFakeGcps,
  type: FAKE_GCPS_UPDATED,
});

export const toggleFakeGcpArchiveStatus = (
  fakeGcpId: string,
  email: string,
): IAction<{ fakeGcpId: string; email: string }> => ({
  payload: { fakeGcpId, email },
  type: FAKE_GCP_ARCHIVE_STATUS_TOGGLED,
});

interface IRenameFakeGcpParams {
  id: string;
  newName: string;
}

export const renameFakeGcp = (
  id: string,
  newName: string,
): IAction<IRenameFakeGcpParams> => ({
  payload: { id, newName },
  type: FAKE_GCP_RENAMED,
});

const defaultState: IFakeGcpsState = [];

export default function fakeGCPReducer(
  state: IFakeGcpsState = defaultState,
  action: IAction<any>,
): IFakeGcpsState {
  switch (action.type) {
    case FAKE_GCPS_UPDATED:
      return action.payload;
    case FAKE_GCP_ARCHIVE_STATUS_TOGGLED:
      return mArchiveFakeGcp(state, action.payload);
    case FAKE_GCP_RENAMED:
      return mRenameFakeGcp(state, action.payload.id, action.payload.newName);
    default:
      return state;
  }
}

export const getActiveFakeGcpFlightMarkers = (
  state: IFakeGcpsState,
): IFakeGcp[] => state.filter((fakeGcp) => !fakeGcp.tsArchived);

export const getArchivedFakeGcps = (state: IFakeGcpsState): IFakeGcp[] =>
  state.filter((fakeGcp) => fakeGcp.tsArchived);

export const getFakeGcpById = (
  state: IFakeGcpsState,
  fakeGcpId: string,
): IFakeGcp => state.find(({ id }) => id === fakeGcpId);

export function mArchiveFakeGcp(
  state: IFakeGcpsState,
  { fakeGcpId, email }: { fakeGcpId: string; email: string },
): IFakeGcpsState {
  const newState = [...state];

  const fakeGcp = newState.find(({ id }) => id === fakeGcpId) || null;
  if (fakeGcp) {
    const isArchived = !fakeGcp.tsArchived;
    // @TODO refactor this to use the /archive endpoint
    if (isArchived) {
      fakeGcp.archivedBy = email;
      fakeGcp.tsArchived = new Date().toISOString();
    } else {
      fakeGcp.archivedBy = null;
      fakeGcp.tsArchived = null;
    }
  }
  return newState;
}

function mRenameFakeGcp(
  state: IFakeGcpsState,
  fakeGcpId: string,
  newName: string,
): IFakeGcpsState {
  const newState = [...state];
  const index = newState.findIndex(({ id }) => id === fakeGcpId);
  newState[index] = { ...newState[index], name: newName };
  return newState;
}
